const breakpoints = {
    xs: 12,
    md: 4,
    sm: 6,
    lg: 4,
}

export default breakpoints
